/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import moment from 'moment';
import _ from 'lodash';

import { Link } from 'react-router-dom';

import { connect } from '../../components/LandingPageDataTable';
import Localized from '../../../shared/components/Localized';

import { DATE_FORMAT, TIME_FORMAT } from "../../../shared/utils/dates";

const columns = [
  {
    title: 'ID',
    key: 'id',
    sizeLarge: 1,
    sizeMedium: 1,
    sizeSmall: 2,
    render: (row) => {
      return (
        <Link
          key={row.id}
          to={{
            pathname: `/maintenances/${row.id}`,
            state: { modal: true }
          }}
        >
          <div>{row.id}</div>
        </Link>
      );
    }
  },

  {
    title: <Localized modelKey='subject' modelAttribute='header' modelName='bucketedList' />,
    key: 'name',
    sizeLarge: 3,
    sizeMedium: 4,
    sizeSmall: 7
  },
  {
    title: <Localized modelKey='instances' modelAttribute='header' modelName='bucketedList' />,
    key: 'instances',
    render: (row) => (
      row.instanceKeys.map((instanceKey, index) => {
        if (index > 3) {
          return;
        }
        else if (index == 3) {
          return <span key={index}> .... </span>;

        }
        else if(index === row.instanceKeys.length-1) {
          return <Localized modelName={'instance'} modelKey={instanceKey} modelAttribute={'label'} key={index} />;
        }
        else {
          return <span key={index} ><Localized modelName={'instance'} modelKey={instanceKey} modelAttribute={'label'} />, </span>;
        }
      })
    ),
    sizeLarge: 2,
    sizeMedium: 4,
    sizeSmall: 4,
  },
  {
    title: <Localized modelKey='services' modelAttribute='header' modelName='bucketedList' />,
    key: 'services',
    render: (row) => (
      row.serviceKeys.map((serviceKey, index) => {
        if (index === row.serviceKeys.length-1) {
          return <Localized modelName={'service'} modelKey={serviceKey} modelAttribute={'label'} key={index} />;
        }

        return <span key={index} ><Localized modelName={'service'} modelKey={serviceKey} modelAttribute={'label'} />, </span>;
      })
    ),
    sizeLarge: 2,
    sizeMedium: 4,
    hideSmall: true,
  },
  {
    title: <Localized modelKey='type' modelAttribute='header' modelName='bucketedList' />,
    key: 'maintenanceType',
    render: (row) => <Localized modelName={'fieldOption'} modelKey={row.message.maintenanceType} modelAttribute={'label'} />,
    sizeLarge: 2,
    hideMedium: true,
    hideSmall: true,
  }
];

const maintenanceBuckets = [];

const today = moment().startOf('day');
maintenanceBuckets.push({
  title: (rows) => `Today - ${today.format('MMMM')} (${rows.length})`,
  partition: (rows) => rows,
  open: true
});


const filterByString = (value, filterState) => {
  const searchString = value ? value.toUpperCase() : '';

  return searchString.includes(filterState.toUpperCase());
};

const filterByDate = (date, filterState) => {
  return date.format(DATE_FORMAT).includes(filterState)
    || date.format(TIME_FORMAT).includes(filterState);
};

const filterByInstanceKey = (instances, filterState) => {
  let shouldInclude = false;
  _.forEach(instances, (instance) => {
    shouldInclude = instance.toUpperCase().includes(filterState.toUpperCase());
    if (shouldInclude) return false;
  });
  return shouldInclude;
};

const filterColumns = [{
  key: 'name',
  test: filterByString
}, {
  key: 'plannedStartTime',
  test: filterByDate
}, {
  key: 'instanceKeys',
  test: filterByInstanceKey
}];

function filter(row, filterState) {

  if (filterState === '') return true; // If no filter set, all maintenances match
  let shouldInclude = false;

  _.forEach(filterColumns, (column) => {
    if (row[column.key]) {
      shouldInclude = column.test(row[column.key], filterState);
      if (shouldInclude) return false;
    }
  });
  return shouldInclude;
}

function sort(a, b) {
  return a.plannedStartTime.diff(b.plannedStartTime);
}

export default connect(columns, maintenanceBuckets, filter, sort);

